import { z } from 'zod';
import { VALID_ROLES } from '../constants/roles.js';

/**
 * Login request schema
 */
export const loginSchema = z.object({
  email: z.string().email('Invalid email address'),
  password: z.string().min(1, 'Password is required'),
});

export type LoginRequest = z.infer<typeof loginSchema>;

/**
 * Create user request schema (admin only)
 */
export const createUserSchema = z.object({
  email: z.string().email('Invalid email address'),
  full_name: z.string().min(1, 'Full name is required'),
  role: z.enum(VALID_ROLES as [string, ...string[]], {
    errorMap: () => ({ message: 'Invalid role' }),
  }),
});

export type CreateUserRequest = z.infer<typeof createUserSchema>;

/**
 * Switch persona request schema (POST /api/auth/switch-persona)
 */
export const switchPersonaSchema = z.object({
  target_user_id: z.string().uuid('target_user_id must be a UUID'),
});
export type SwitchPersonaRequest = z.infer<typeof switchPersonaSchema>;

/**
 * Link personas request schema (ADMIN only: POST /api/admin/users/link-personas)
 */
export const linkPersonasSchema = z.object({
  user_ids: z.array(z.string().uuid()).min(2, 'At least 2 user ids are required'),
});
export type LinkPersonasRequest = z.infer<typeof linkPersonasSchema>;

/**
 * Unlink persona request schema (ADMIN only: POST /api/admin/users/unlink-persona)
 */
export const unlinkPersonaSchema = z.object({
  user_id: z.string().uuid(),
});